import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadCrumbService, PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ManageInventoryService, CTNDetails, DeviceInformation, CTNStatus } from './../shared';
import { AccordionComponent, AccordionModel, ConfirmModalPopupModel, StatusBarModel } from 'lib/ng2-sapmp/src/ui-components';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';
import { CHART_CONFIG, MOBILEPIVOTS } from 'config';
import { isString } from 'util';

@Component({
  selector: 'app-ctn-info',
  templateUrl: './ctn-info.component.html',
  styleUrls: ['./ctn-info.component.scss'],
  providers: [ManageInventoryService],
  encapsulation: ViewEncapsulation.None
})
export class CtnInfoComponent implements OnInit {

  deviceId: number;
  ctnDetails: CTNDetails;
  pageData: any;
  deviceInfo: DeviceInformation;
  options: Array<AccordionModel>;
  confirmModalPopup: ConfirmModalPopupModel;
  ctnStatus: CTNStatus;
  colorStatus: String;
  initModal: Boolean = false;
  showSMS: Boolean = false;
  showSupport: Boolean = false;
  smsSent: boolean;
  status: any;
  ctn: any;
  progressChartData: Array<StatusBarModel>;
  isMobile: Boolean = true;
  selectedCtn: any;
  selectedImei: any;
  error: boolean;
  eventEmit: any;
  pivots: Array<MobilePivotModel>;
  permissions: any;
  showReportPopup: boolean;
  showSuccessLock: boolean;
  // showErrorLock: boolean;
  showSuccessWipe: boolean;
  // showErrorWipe: boolean;
  supportArticle = false;
  deviceDeenrolled = false;
  wiped = false;
  locked = false;
  initDeviceLockModal = false;
  initDeviceWipeModal = false;
  showLIC: boolean;
  modalClass: string;
  article: any;
  showPopup = false;
  title: string;
  errorMessage: string;
  emmProductCode: any;
  oemStatus: boolean;
  responseData: any;
  serviceType: string;
  enrollmentStatusReason: any;
  oemEnrollmentStatus: any;
  displayEnrollIcon = false;//show or hide icon pic
  displayUnenrollIcon = false; 
  claimFuncEnable = true; //enable or disable claim function
  unclaimFuncEnable = true;
  disableTextButton: boolean = false;
  imeiList:string;

  initClaimUnclaim: boolean = false;
  showErrorClaimUnclaim: boolean = false;
  showSuccessClaimUnclaim: boolean = false;
  enrollStatus = "CLAIM_FAILED";
  claimDisabledBtn: boolean = false;
  claimUnclaimInfo = {
    name: "",
    title: ""
  }
  productIdName: string;
  productName: string;
  productId: string;
  // NOT_CLAIMED        NO NO    
  // CLAIM_INITIATED    YES   
  // CLAIM_INPROGRESS   YES  
  // CLAIM_FAILED       YES
  // CLAIM_SUCCESS      NO
  // UNCLAIM_INITIATED  NO
  // UNCLAIM_INPROGRESS NO
  // UNCLAIM_FAILED     NO

  constructor(private breadCrumbService: BreadCrumbService,
    private manageInventoryService: ManageInventoryService,
    private activatedRoute: ActivatedRoute,
    private utilityService: UtilityService, private adobeAnalyticsService: AdobeAnalyticsService,
    private router: Router, private pageLoaderService: PageLoaderService) {
    this.pageLoaderService.setPageLoaderStatus(false);
    this.ctnDetails = new CTNDetails();
    this.deviceInfo = new DeviceInformation();
    this.options = [];
    this.ctnStatus = new CTNStatus();
    this.progressChartData = [];
    this.showSuccessLock = false;
    // this.showErrorLock = false;
    this.showSuccessWipe = false;
    // this.showErrorWipe = false;
    const permission = sessionStorage.getItem('permissions');
    if (permission !== 'null') {
      this.permissions = JSON.parse(permission);
    }
  }

  ngOnInit() {
    const pageName = 'ctnInfoPage';
    this.disableTextButton = false;
    this.manageInventoryService.requestSupportContent(this.utilityService.getEnvConfig().getSupportDocument + pageName).
      subscribe(resp => {
        this.supportArticle = true;
        this.article = resp.supportArticles;
        this.article.category = this.article.availableArticle;
        // }, (err) => {
        //     this.handleError(err);
      });
    this.emmProductCode = JSON.parse(sessionStorage.getItem('mdmDetails')).productCode;
    if (this.emmProductCode === 'ADDPZTE') {
      this.oemStatus = true;
    } else {
      this.oemStatus = false;
    }
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.showLIC = JSON.parse(sessionStorage.getItem('user')).user.roles === 'LIC' &&
      sessionStorage.getItem('client') !== null && sessionStorage.getItem('client').toUpperCase() === 'UD';
    this.pivots = MOBILEPIVOTS.CTNINFO;
    // this.breadCrumbService.setCurrentBreadCrumb({ label: 'CTN', routerLink: 'manageInventory/ctnInfo' });
    const ctnObjFromSession = JSON.parse(sessionStorage.getItem('ctnDetails'));
    //this.manageInventoryService.getCtnPageDetails(this.utilityService.getEnvConfig().contentUrl.manageInventory.ctnViewData)
    // .subscribe(response => {
    this.pageData = this.activatedRoute.snapshot.data.pageData.manageInventoryctnInfo.CTN;
    this.checkCtn();
    const path = this.breadCrumbService.getBreadCrumbs();
    const len = path.length;
    const previousRoute = path[len - 1].routerLink;
    if (ctnObjFromSession && previousRoute !== 'manageInventory/deviceInventory' && previousRoute !== 'manageInventory/ctnInfo') {
      this.ctnDetails = ctnObjFromSession;
      this.responseData = this.ctnDetails;
      if (this.ctnDetails.ctnStatus && this.ctnDetails.ctnStatus.enrollmentStatus !== 'ENROLLED_ACTIVE') {
        this.deviceDeenrolled = true;
      }
      if (this.ctnDetails.deviceInfo) {
        if (this.ctnDetails.deviceInfo.platform == 'Android' || this.ctnDetails.deviceInfo.platform == 'ANDROID') {
          this.ctnDetails.deviceInfo.platform = 'Android™';
        }

        sessionStorage.setItem('currentCtnDetails', JSON.stringify({
          emmTenantId: this.ctnDetails.deviceInfo.emmTenantId,
          emmDeviceId: this.ctnDetails.deviceInfo.emmDeviceId,
          deviceId:this.ctnDetails.deviceInfo.deviceId,
          locked: this.locked,
          wiped: this.wiped,
          deviceDeenrolled: this.deviceDeenrolled
        }));
      }

      this.manageInventoryService.createPageLoadProperties('CTN_INFO', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);
      this.getCtnDetails();
      this.pageLoaderService.setPageLoaderStatus(true);
    } else {
      if (previousRoute !== 'manageInventory/ctnInfo' && (this.selectedCtn === "Unknown" || this.selectedCtn === "" || this.selectedCtn === null)) {
        //implement similar flow as below but for imei dets.
        this.selectedImei = JSON.parse(sessionStorage.getItem('imeiNumber'));
        this.manageInventoryService.getImeiDetails(this.selectedImei)
          .subscribe(resObj => {
            this.ctnDetails = resObj.ctnDetailsResponseList[0];
            this.responseData = resObj.ctnDetailsResponseList[0];

            if (this.ctnDetails.ctnStatus && this.ctnDetails.ctnStatus.enrollmentStatus !== 'ENROLLED_ACTIVE') {
              this.deviceDeenrolled = true;
            }
            if (this.ctnDetails.deviceInfo.platform === 'Android' || this.ctnDetails.deviceInfo.platform === 'ANDROID') {
              this.ctnDetails.deviceInfo.platform = 'Android™';
            }
            if (this.ctnDetails.deviceInfo.platform === null) {
              this.ctnDetails.deviceInfo.platform = 'Unknown';
            }
            if (this.ctnDetails.emailId === null) {
              this.ctnDetails.emailId = 'Unknown';
            }
            if (this.ctnDetails.deviceInfo) {
              sessionStorage.setItem('currentCtnDetails', JSON.stringify({
                emmTenantId: this.ctnDetails.deviceInfo.emmTenantId,
                emmDeviceId: this.ctnDetails.deviceInfo.emmDeviceId,
                deviceId:this.ctnDetails.deviceInfo.deviceId,
                locked: this.locked,
                wiped: this.wiped,
                deviceDeenrolled: this.deviceDeenrolled,
              }));
            }

            this.manageInventoryService.createPageLoadProperties('CTN_INFO', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);
            this.getCtnDetails();
            this.pageLoaderService.setPageLoaderStatus(true);
            this.disableTextButton = false;
          }, (err) => {
            this.handleError(err);
            this.disableTextButton = true;
            this.pageData.navLinks.forEach(element => {
              if (element.fieldPermission !== 'ctnInfo.reports') {
                this.disableNavLinks(element);
              }
            });
          });
        
      } else {
        this.manageInventoryService.getCtnDetails(this.selectedCtn)
          .subscribe(resObj => {
            this.ctnDetails = resObj.ctnDetailsResponseList[0];
            this.responseData = resObj.ctnDetailsResponseList[0];

            if (this.ctnDetails.ctnStatus && this.ctnDetails.ctnStatus.enrollmentStatus !== 'ENROLLED_ACTIVE') {
              this.deviceDeenrolled = true;
            }
            if (this.ctnDetails.deviceInfo.platform === 'Android' || this.ctnDetails.deviceInfo.platform === 'ANDROID') {
              this.ctnDetails.deviceInfo.platform = 'Android™';
            }
            if (this.ctnDetails.deviceInfo.platform === null) {
              this.ctnDetails.deviceInfo.platform = 'Unknown';
            }
            if (this.ctnDetails.emailId === null) {
              this.ctnDetails.emailId = 'Unknown';
            }
            if (this.ctnDetails.deviceInfo) {
              sessionStorage.setItem('currentCtnDetails', JSON.stringify({
                emmTenantId: this.ctnDetails.deviceInfo.emmTenantId,
                emmDeviceId: this.ctnDetails.deviceInfo.emmDeviceId,
                deviceId:this.ctnDetails.deviceInfo.deviceId,
                locked: this.locked,
                wiped: this.wiped,
                deviceDeenrolled: this.deviceDeenrolled
              }));
            }

            this.manageInventoryService.createPageLoadProperties('CTN_INFO', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);
            this.getCtnDetails();
            this.enrollStatus = this.ctnStatus.enrollmentStatus.toUpperCase()
            console.log(this.enrollStatus)
            this.pageLoaderService.setPageLoaderStatus(true);
            this.disableTextButton = false;
          }, (err) => {
            this.handleError(err);
            this.disableTextButton = true;
            this.pageData.navLinks.forEach(element => {
              if (element.fieldPermission !== 'ctnInfo.reports') {
                this.disableNavLinks(element);
              }
            });
          });
      }
    }
    
    this.manageInventoryService.createPageLoadProperties('CTN_INFO', 'CtnInfo');
    sessionStorage.getItem('previousRoute') === '/manageInventory' ? this.getProfileID() : null;
  }

  getProfileID() {
    this.manageInventoryService.getSingleDevicesInventory([this.ctnDetails.fan])
      .subscribe(respobj => {
        sessionStorage.getItem('ProfileID') ? sessionStorage.removeItem('ProfileID') : null;
        if (respobj.devicesSummary) {
          sessionStorage.setItem('ProfileID', respobj.devicesSummary[0].profile.profileId);
        }
        else {
          sessionStorage.setItem('ProfileID', respobj.profile.profileId);
        }
      })
  }

  handleError(error) {
    this.error = true;
    if (error === 'showErrorWipe' || error === 'showErrorLock') {
      this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
    } else {
      this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
    }

    this.pageLoaderService.setPageLoaderStatus(true);
  }

  navigate(route) {
    this.showSuccessWipe = false;
    this.showSuccessClaimUnclaim = false;
    this.smsSent = false;
    this.showSuccessLock = false;
    this.showSuccessWipe = false;
    let url;
    if (route === '/sendMessage') {
      this.manageInventoryService.createPageLoadProperties('SEND_MESSAGE_MODAL', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);
      this.showSupport = false;
      this.initModal = true;
      this.showSMS = true;
      this.modalClass = 'add-scroll';
      this.eventEmit = document.activeElement;
    } else if (route === '/lockDevice') {
      this.manageInventoryService.createPageLoadProperties('LOCKDEVICE', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);
      this.initDeviceLockModal = true;
      url = '/virtual/manageDevice/lockmodal.html';
      this.eventEmit = document.activeElement;
    } else if (route === '/reports') {
      this.initReportPopupModal();
    } else if (route === '/wipeDevice') {
      this.manageInventoryService.createPageLoadProperties('WIPEDEVICE', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);
      url = '/virtual/manageDevice/wipemodal.html';
      this.initDeviceWipeModal = true;
      this.eventEmit = document.activeElement;
    } else {
      this.router.navigate([route]);
      this.modalClass = '';
    }
    this.adobeAnalyticsService.trackPageProperties(); // Temp URL Fix
  }

  getCtnDetails() {

    const currentCtnDetails = JSON.parse(sessionStorage.getItem('currentCtnDetails'));
    if (currentCtnDetails) {
      this.deviceDeenrolled = currentCtnDetails.deviceDeenrolled;
      this.wiped = currentCtnDetails.wiped;
      this.locked = currentCtnDetails.locked;
    }

    this.deviceInfo = this.ctnDetails.deviceInfo;
    if(this.deviceInfo.complianceStatus === "Unknown" || this.deviceInfo.complianceStatus === undefined || this.deviceInfo.complianceStatus === "" || this.deviceInfo.complianceStatus === null){
      this.imeiList = String(this.deviceInfo.imei);
    }else{
      this.imeiList = this.deviceInfo.imei+', '+this.deviceInfo.complianceStatus;
    }
    this.ctnStatus = this.ctnDetails.ctnStatus;
    if (this.ctnDetails.ctnStatus.complianceStatus === 'true' || this.ctnDetails.ctnStatus.complianceStatus === 'IN_COMPLIANCE') {
      this.ctnStatus.complianceStatus = 'Compliant';
    } else if (this.ctnDetails.ctnStatus.complianceStatus === 'false' ||
      this.ctnDetails.ctnStatus.complianceStatus === 'OUT_OF_COMPLIANCE') {
      this.ctnStatus.complianceStatus = 'Not Compliant';
    } else {
      this.ctnStatus.complianceStatus = '';
    }
    if (this.ctnDetails.ctnStatus.applicationStatus && this.ctnDetails.ctnStatus.applicationStatus.length > 0) {
      this.ctnStatus.applicationStatus = this.ctnDetails.ctnStatus.applicationStatus;
    } else {
      this.ctnStatus.applicationStatus = undefined;
    }
    if (this.ctnDetails.ctn) {
      this.ctn = this.ctnDetails.ctn.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1.$2.$3');
    }
    if (this.ctnDetails.ctn == null || this.ctnDetails.ctn == "" || this.ctnDetails.ctn == "Unknown") {
      this.ctn = "Unknown";
    }
    if (this.ctnDetails.emailId == null || this.ctnDetails.emailId == "") {
      this.ctnDetails.emailId = "Unknown";
    }
    if (this.ctnDetails.userName == null || this.ctnDetails.userName == "") {
      this.ctnDetails.userName = "Unknown";
    }
    if (this.ctnDetails.groupName == null || this.ctnDetails.groupName == "") {
      this.ctnDetails.groupName = "Unknown";
    }
    if (this.ctnDetails.ratePlan == null || this.ctnDetails.ratePlan == "") {
      this.ctnDetails.ratePlan = "Unknown";
    }
    if (this.ctnDetails.userId == null || this.ctnDetails.userId == "") {
      this.ctnDetails.userId = "Unknown";
    }
    if (this.ctnDetails.deviceInfo.platform == null || this.ctnDetails.deviceInfo.platform == "") {
      this.ctnDetails.deviceInfo.platform = "Unknown";
    }


    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Wireless number ' + this.ctn, routerLink: 'manageInventory/ctnInfo' });
    const chartConfig = CHART_CONFIG[this.ctnDetails.ctnStatus.enrollmentStatus];
    if (!this.deviceInfo) {
      this.nullCapture('deviceInfo');
    }
    if (!this.ctnStatus) {
      this.nullCapture('ctnStatus');
    } else {
      if (typeof chartConfig !== 'undefined') {
        let status = chartConfig.label;
        if (status === 'enrolled, active') {
          status = 'Enrolled, active';
        } else if (status === 'not compliant') {
          status = 'Not compliant';
        } else if (status === 'enrolled, not active') {
          status = 'Enrolled, not active';
        } else if (status === 'not enrolled') {
          status = 'Not enrolled';
        }
        const temp: any = {
          'color': chartConfig.color,
          'legend': status
        };
        this.progressChartData.push(temp);

        let ctnData = this.responseData.ctnStatus;

        // For OEM case
        if (ctnData.enrollmentStatus) {
          let enrollmentStatus = ctnData.enrollmentStatus.replace(/_/g, ' ');

          if (enrollmentStatus === 'ENROLLED ACTIVE') {
            enrollmentStatus = 'Enrolled, active';
          } else if (enrollmentStatus === 'OUT OF COMPLIANCE') {
            enrollmentStatus = 'Not compliant';
          } else if (enrollmentStatus === 'ENROLLED NOT ACTIVE') {
            enrollmentStatus = 'Enrolled, not active';
          } else if (enrollmentStatus === 'NOT ENROLLED') {
            enrollmentStatus = 'Not enrolled';
          } else if (enrollmentStatus === 'Claimed Android') {
            enrollmentStatus = 'Claimed (Android™)';
            this.displayUnenrollIcon = true;
          } else if (enrollmentStatus === 'Claimed Android™') {
            enrollmentStatus = 'Claimed (Android™)';
            this.displayUnenrollIcon = true;
          } else if (enrollmentStatus === 'Claimed Samsung') {
            enrollmentStatus = 'Claimed (Samsung)';
            this.displayUnenrollIcon = true;
          } else if (enrollmentStatus === 'Claimed Apple') {
            enrollmentStatus = 'Claimed (Apple)';
            this.displayUnenrollIcon = true;
          }else if (enrollmentStatus === 'Not Claimed' ) {
            enrollmentStatus = 'Not claimed';
            this.displayEnrollIcon = true;
          }else if (enrollmentStatus === 'CLAIM PENDING' ) {
            enrollmentStatus = 'Claim pending';
            this.displayEnrollIcon = true;
          }else if (enrollmentStatus === 'UNCLAIM PENDING' ) {
            enrollmentStatus = 'Unclaim pending';
            this.displayUnenrollIcon = true;
          }else if (enrollmentStatus === 'UNCLAIM PENDING Android') {
            enrollmentStatus = 'Unclaim pending (Android™)';
            this.displayUnenrollIcon = true;
          }else if (enrollmentStatus === 'UNCLAIM PENDING Android™') {
            enrollmentStatus = 'Unclaim pending (Android™)';
            this.displayUnenrollIcon = true;
          }else if (enrollmentStatus === 'UNCLAIM PENDING Samsung') {
            enrollmentStatus = 'Unclaim pending (Samsung)';
            this.displayUnenrollIcon = true;
          }else if (enrollmentStatus === 'UNCLAIM PENDING Apple') {
            enrollmentStatus = 'Unclaim pending (Apple)';
            this.displayUnenrollIcon = true;
          }else if (enrollmentStatus === 'CLAIM PENDING Android') {
            enrollmentStatus = 'Claim pending (Android™)';
            this.displayEnrollIcon = true;
          }else if (enrollmentStatus === 'CLAIM PENDING Android™') {
            enrollmentStatus = 'Claim pending (Android™)';
            this.displayEnrollIcon = true;
          }else if (enrollmentStatus === 'CLAIM PENDING Samsung') {
            enrollmentStatus = 'Claim pending (Samsung)';
            this.displayEnrollIcon = true;
          }else if (enrollmentStatus === 'CLAIM PENDING Apple') {
            enrollmentStatus = 'Claim pending (Apple)';
            this.displayEnrollIcon = true;
          }

          this.oemEnrollmentStatus = enrollmentStatus;
        }


        // Display Enroll/Unenroll based on CDFStatus
        if (ctnData.enrollmentStatusCDF) {

          let enrollmentStatusCDF = ctnData.enrollmentStatusCDF;

          if(enrollmentStatusCDF === 'NOT_CLAIMED' || enrollmentStatusCDF === 'CLAIM_FAILED' || enrollmentStatusCDF === 'UNCLAIM_SUCCESS'){
            this.claimFuncEnable = false;
          }else if(enrollmentStatusCDF === 'CLAIM_SUCCESS' || enrollmentStatusCDF === 'UNCLAIM_FAILED' ){
            this.unclaimFuncEnable = false;
          }

          // If enrollmentStatusCDF is CLAIM_FAILED, do not show the program/service
          if (enrollmentStatusCDF === 'CLAIM_FAILED') {
            ctnData.serviceType = undefined;
          }
        }

        if (ctnData.serviceType) {
          this.serviceType = ctnData.serviceType;
          if (this.serviceType === 'SAMSUNG_KME') {
            this.serviceType = 'Samsung Knox Mobile Enrollment';
          } else if (this.serviceType === 'Android_ZTE') {
            this.serviceType = 'Android™ zero-touch enrollment';
          }else if (this.serviceType === 'APPLE_ABM') {
            this.serviceType = 'Apple Business Manager';
          }
        }

        if (ctnData.enrollmentStatusReason) {
          this.enrollmentStatusReason = ctnData.enrollmentStatusReason.split(" ");
          if (this.enrollmentStatusReason[7] === 'GMT') {
            this.enrollmentStatusReason = `${this.enrollmentStatusReason[4]} ${this.enrollmentStatusReason[5]} 
        ${this.enrollmentStatusReason[8]} ${this.enrollmentStatusReason[6]} 
        ${this.enrollmentStatusReason[7]}`;
          }
          else {
            this.enrollmentStatusReason = ctnData.enrollmentStatusReason;
          }
        }


      }
    }

    this.buildAccordion();
    this.disableWipeDevice();
    this.pageData.navLinks.forEach(element => {
      this.disableNavLinks(element);
    });
    sessionStorage.removeItem('imeiNumber');
    //sessionStorage.removeItem('ctnNumber');
  }

  nullCapture(capture) {
    if (capture === 'deviceInfo') {
      this.deviceInfo = {
        'deviceName': '',
        'platform': '',
        'os': '',
        'imei': '',
        'complianceStatus': '',
        'checkInDate': '',
        'emmDeviceId': '',
        'emmTenantId': '',
        'emmProvider': '',
        'deviceId':''
      };
    } else if (capture === 'ctnStatus') {
      this.ctnStatus = {
        'enrollmentStatus': '',
        'complianceStatus': '',
        'mobilityStatus': '',
        'applicationStatus': [],
        'programStatus': ''
      };
    }
  }

  buildAccordion() {
    if (window.innerWidth > 1024) {
      this.isMobile = false;
    }
    this.options.push({
      id: 1, isActive: true, category: 'Help', description: '', ariaLabel: {
        'expand': 'Show help',
        'collapse': 'Hide help'
      }
    });
  }

  /* modal popover if support link is clicked from accordion */
  launchSupportModal(modalName) {
    this.confirmModalPopup = new ConfirmModalPopupModel();
    /*this.confirmModalPopup.modalMessage = `
      <p>Message related to support</p>
      ` ;*/
    this.confirmModalPopup.modalSubHeader = '';
    if (modalName === 'lock') {
      this.manageInventoryService.createPageLoadProperties('LOCKDEVICE', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);
      this.manageInventoryService.requestPopupContent(this.utilityService.getEnvConfig().getSupportDocument[0]).
        subscribe(
          res => {
            this.confirmModalPopup.modalMessage = res.content;
          });
      this.confirmModalPopup.modalHeader = this.pageData.linkText[0];
    } else if (modalName === 'wipe') {
      this.manageInventoryService.createPageLoadProperties('WIPEDEVICE', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);
      this.manageInventoryService.requestPopupContent(this.utilityService.getEnvConfig().getSupportDocument[1]).
        subscribe(
          res => {
            this.confirmModalPopup.modalMessage = res.content;
          });
      this.confirmModalPopup.modalHeader = this.pageData.linkText[1];
    } else {
      this.router.navigateByUrl('/faq?id=9');
    }
    this.confirmModalPopup.confirmButtonMessage = 'OK';
    this.confirmModalPopup.showCancelButton = false;
    this.showSMS = false;
    this.initModal = true;
    this.showSupport = true;
    // this.eventEmit = document.activeElement;
  }

  closeModal(confirm) {
    this.manageInventoryService.createPageLoadProperties('CTN_INFO', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);
    this.initModal = false;
    this.showSMS = false;
    this.showSupport = false;
    this.smsSent = sessionStorage.getItem('smsSent') ? true : false;
    sessionStorage.removeItem('smsSent');
  }

  onFanClick() {
    this.manageInventoryService.setSelectedFan(this.ctnDetails.fan);
    this.router.navigate(['manageInventory/deviceInventory']);
  }

  checkCtn() {
    this.selectedCtn = this.manageInventoryService.getSelectedCtn();
    if (this.selectedCtn === undefined) {
      this.router.navigate(['manageInventory/deviceInventory']);
    }
    else if (isNaN(parseInt(this.selectedCtn))) {
      if (this.selectedCtn != null) {
        if (this.selectedCtn != "Unknown") {
          this.router.navigate(['manageInventory/deviceInventory']);
        }
      }
    }
  }

  viewProfile() {
    this.manageInventoryService.setSelectedProfileID(sessionStorage.getItem('ProfileID'));
    this.router.navigate(['manageInventory/fanDeploymentProfile']);
  }

  dismissInfo() {
    this.smsSent = false;
    this.showSuccessLock = false;
    this.showSuccessWipe = false;
    this.showSuccessClaimUnclaim = false;
    this.error = false;
    this.showErrorClaimUnclaim = false;
  }

  disableNavLinks(field) {
    field.disable = false;
    if ((this.deviceDeenrolled || this.wiped || this.locked) && field.fieldPermission === 'ctnInfo.lockDevice') {
      field.disable = true;
      field.imgUrl = field.disabledImgUrl;
    } else if (this.wiped && field.fieldPermission === 'ctnInfo.wipeDevice') {
      field.disable = true;
      field.imgUrl = field.disabledImgUrl;
    }
    if (((field.fieldPermission === 'ctnInfo.lockDevice' || field.fieldPermission === 'ctnInfo.wipeDevice') &&
      this.ctnStatus.enrollmentStatus !== 'ENROLLED_ACTIVE') ||
      this.utilityService.checkFieldPermission(field.fieldPermission, this.permissions.perm) || this.error) {
      field.disable = true;
      field.imgUrl = field.disabledImgUrl;
    }
  }
  // Report pop up functionality
  initReportPopupModal() {
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.showReportPopup = true;
    this.eventEmit = document.activeElement;
    this.manageInventoryService.createPageLoadProperties('REQUEST_REPORTS_MODAL', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);

  }

  closeReportPopup() {
    this.showReportPopup = false;

    this.manageInventoryService.createPageLoadProperties('CTN_INFO', 'CtnInfo', this.ctnDetails.ctn, this.ctnDetails.ban);

  }

  showSuccessMessageLock(value) {
    this.showSuccessWipe = false;
    this.locked = true;
    this.initDeviceLockModal = false;
    this.pageData.navLinks.forEach(element => {
      this.disableNavLinks(element);
    });
    if (value) {
      this.showSuccessLock = true;
    } else {
      this.handleError('showErrorLock');
      // this.showErrorLock = true;
    }
  }

  showSuccessMessageWipe(device) {
    this.showSuccessLock = false;
    this.deviceDeenrolled = device.deenrolled;
    this.wiped = device.wiped;
    this.initDeviceWipeModal = false;
    if (device.wiped && !device.deenrolled) {
      this.ctnStatus.complianceStatus = 'Not compliant';
      const chartConfig = CHART_CONFIG['NOT_ENROLLED'];
      const temp: any = {
        'color': chartConfig.color,
        'legend': 'Pending'
      };
      this.progressChartData[0] = temp;
      this.showSuccessWipe = true;
      this.pageData.navLinks.forEach(element => {
        this.disableNavLinks(element);
      });
    } else if (device.wiped && device.deenrolled) {
      this.showSuccessWipe = true;
      this.ctnStatus.complianceStatus = 'Unenrolled';
      const chartConfig = CHART_CONFIG['NOT_ENROLLED'];
      const temp: any = {
        'color': chartConfig.color,
        'legend': 'Pending'
      };
      this.progressChartData[0] = temp;
      this.pageData.navLinks.forEach(element => {
        this.disableNavLinks(element);
      });
    } else {
      this.handleError('showErrorWipe');
      // this.showErrorWipe = true;
    }
  }


  closeDeviceLockModal(value) {
    this.initDeviceLockModal = false;
  }

  closeDeviceWipeModal(value) {
    this.initDeviceWipeModal = false;
  }

  disableWipeDevice() {
    if (this.deviceDeenrolled && this.wiped) {
      // changing compliance status
      this.ctnStatus.complianceStatus = this.ctnDetails.ctnStatus.complianceStatus;
      // changing enrollment status
      const chartConfig = CHART_CONFIG['NOT_ENROLLED'];
      const temp: any = {
        'color': '',
        'legend': 'Pending Wipe'
      };
      this.progressChartData[0] = temp;

      // for device wiped only
    } else if (!this.deviceDeenrolled && this.wiped) {
      // changing compliance status
      this.ctnStatus.complianceStatus = this.ctnDetails.ctnStatus.complianceStatus;
      // changing enrollment status
      const chartConfig = CHART_CONFIG['NOT_ENROLLED'];
      const temp: any = {
        'color': '',
        'legend': 'Pending Wipe'
      };
      this.progressChartData[0] = temp;
    }
  }

  getSupportContent(articleNumber) {
    if (this.article.availableArticle[articleNumber].type === 'popup') {
      this.initPopupModal(this.article.availableArticle[articleNumber].title, articleNumber);
    } else if (this.article.availableArticle[articleNumber].type === 'url') {
      this.router.navigateByUrl(this.article.availableArticle[articleNumber].url);
    }
  }

  initPopupModal(modalName, articleNumber) {
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.confirmModalPopup.modalSubHeader = '';
    this.manageInventoryService.requestPopupContent(this.utilityService.getEnvConfig().getSupportDocument + 'details/' + modalName).
      subscribe(
        res => {
          this.title = res.articleDetails.name;
          this.confirmModalPopup.modalHeader = this.article.availableArticle[articleNumber].name;
          this.confirmModalPopup.modalMessage = res.articleDetails.content;
        });
    this.confirmModalPopup.confirmButtonMessage = 'OK';
    this.confirmModalPopup.showCancelButton = false;
    this.showSMS = false;
    this.initModal = true;
    this.showSupport = true;
    this.eventEmit = document.activeElement;
    this.showPopup = true;
  }

  // added for device lock and wipe userstory
  check(route) {
    if ((this.deviceDeenrolled || this.wiped) && route === '/lockDevice') {
      return true;
    } else if (this.wiped && route === '/wipeDevice') {
      return true;
    } else if (this.wiped && this.deviceDeenrolled && route === '/sendMessage') {
      return true;
    } else if (this.ctnDetails.ctn == "Unknown" || this.ctnDetails.ctn == "" || this.ctnDetails.ctn == null) {
      return true;
    } else if (this.disableTextButton == true) {
      return true;
    }
    return false;
  }
  // initClaimUnclaim: boolean = false;
  // showErrorClaimUnclaim: boolean = true;
  // showSuccessClaimUnclaim: boolean = true;
  claimDevice() {
    this.claimUnclaimInfo.name = "claim";
    this.claimUnclaimInfo.title = "Claim Device";
    this.initClaimUnclaim = true;
    this.showErrorClaimUnclaim = false;
    this.showSuccessClaimUnclaim = false;
    const productCode = this.deviceInfo.emmDeviceId.split("_")
    this.eventEmit = document.activeElement;
    console.log(productCode);//DMPAABM_10001  
    // DMPGZTP DMPSKME DMPAABM
    if(productCode[0] === "DMPAABM"){
      this.productIdName = "Apple Organization Id";
      this.productId = productCode[1];
    }else if(productCode[0] === "DMPSKME") {
      this.productIdName = "Knox Mobile Enrollment ID";
      this.productId = productCode[1];
    }else if(productCode[0] === "DMPGZTP") {
      this.productIdName = "GOOGLE ID";
      this.productId = productCode[1];
    }
  }

  unClaimDevice() {
    this.claimUnclaimInfo.name = "unclaim";
    this.claimUnclaimInfo.title = "Unclaim Device";
    this.initClaimUnclaim = true;
    this.showErrorClaimUnclaim = false;
    this.showSuccessClaimUnclaim = false;
    const productCode = this.deviceInfo.emmDeviceId.split("_")
    this.eventEmit = document.activeElement;
    console.log(productCode);//DMPAABM_10001
    // DMPGZTP DMPSKME DMPAABM
    if(productCode[0] === "DMPAABM"){
      this.productIdName = "Apple Organization Id";
      this.productName = "ABM";
      this.productId = productCode[1];
    }else if(productCode[0] === "DMPSKME") {
      this.productIdName = "Knox Mobile Enrollment ID";
      this.productName = "KME";
      this.productId = productCode[1];
    }else if(productCode[0] === "DMPGZTP") {
      this.productIdName = "GOOGLE ID";
      this.productName = "ZTE";
      this.productId = productCode[1];
    }
  }

  async ok(status) {
    let companyId = JSON.parse(sessionStorage.getItem('user')).user.companyId;
    console.log(companyId)
    let claimPayload;
    if(status === "claim") {
      claimPayload = {
        "eventName": "ENROLL",
        "eventPayload": {
          "fan": this.ctnDetails.fan,
          "companyId": companyId,
          "imei": this.ctnDetails.deviceInfo.imei,
          "ctn": this.ctnDetails.ctn,
          "ban": this.ctnDetails.ban,
          "emmProductCode":this.deviceInfo.emmDeviceId.split("_")[0]
        }
      }
      this.claimUnclaimInfo.name = "claim";
      this.claimUnclaimInfo.title = "Claim Device";
      this.enrollStatus = "CLAIM_INITIATED";
      // claim-initated
    } else {
      claimPayload = {
        "eventName": "DEENROLL",
        "eventPayload": {
          "fan": this.ctnDetails.fan,
          "imei": this.ctnDetails.deviceInfo.imei,
          "ctn": this.ctnDetails.ctn,
          "ban": this.ctnDetails.ban,
          "emmDeviceId": this.ctnDetails.deviceInfo.emmDeviceId,
          "deviceId":this.ctnDetails.deviceInfo.deviceId
        }
      }
      this.claimUnclaimInfo.name = "unclaim";
      this.claimUnclaimInfo.title = "Unclaim Device";
      this.enrollStatus = "UNCLAIM_INITIATED";
      // unclaim-initiated
    }
    console.log("claimPayload::::::"+claimPayload)
    // api call happen
    this.pageLoaderService.setPageLoaderStatus(false);
    try {
      const response = await this.manageInventoryService.updateCtnDetails(claimPayload);
      console.log("response:::::"+ response);
      
            this.initClaimUnclaim = false;
            this.showSuccessClaimUnclaim = true;
            this.showErrorClaimUnclaim = false;
            this.smsSent = false;
            this.claimFuncEnable = true;
            this.unclaimFuncEnable = true;
            this.showErrorClaimUnclaim = false
    } catch (error) {
      console.log("error in catch block:::::"+ error);
          this.initClaimUnclaim = false;
          this.showSuccessClaimUnclaim = false;
          this.showErrorClaimUnclaim = true;
          this.smsSent = false;
    }
    this.pageLoaderService.setPageLoaderStatus(true);
  }
  
  closeModalClaimUnclaim(value) {
    // document.body.classList.remove('modal-open');
    this.initClaimUnclaim = false;
  }
}
